module.exports = __webpack_public_path__ + "static/media/bankYk.61954bb3.png";